// extracted by mini-css-extract-plugin
export default {"link_container":"TFALink_link_container__+tnW7","forward":"TFALink_forward__o5r41","backward":"TFALink_backward__uKt-E"};